import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { PublishedEventTypes } from '../../../constants/publishedEvent';
import { isSystemAdmin } from '../../../services';
import { publisherPortalActions } from '../../../state/modules/publisher-portal';
import { currentUserSelector } from '../../../state/modules/user';
import PublishedEvents from './../shared/publish-event/events';

const mapStateToProps = (state) => ({
  eventsResult: state.publisherPortal.events.eventsResult,
  isFetchingEvents: state.publisherPortal.events.isFetching,
  isFetching: state.cpdCategorys.isFetching ||
    state.publisherPortal.events.isFetching ||
    state.publisherPortal.events.isLoadingMore,
  eventDetailsRoute: routes.publisherPortal.publishedEventDetails,
  eventEditRoute: routes.publisherPortal.publishedEventEdit,
  allowDelete: fp.overSome([isSystemAdmin])(currentUserSelector(state))
});

const mapDispatchToProps = (dispatch) => ({
  loadMoreEvents: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.loadMore, dispatch),
  getEvents: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.get, dispatch),
  deleteEvent: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.deleteEvent, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    () => ({
      eventType: PublishedEventTypes.Event
    })
  )
)(PublishedEvents);


// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/events.js